// ==========================
// src/components/Section.jsx
// ==========================
import React from 'react';
import { Container, Typography, Box } from '@mui/material';

export default function Section({ id, title, children, alt=false }){
  return (
    <Box id={id} className={`section ${alt ? 'section-alt' : ''}`}>
      <Container>
        {title && (
          <Typography variant="h4" sx={{ fontWeight: 800, mb: 2 }}>{title}</Typography>
        )}
        <Typography variant="body1" component="div">
          {children}
        </Typography>
      </Container>
    </Box>
  );
}